<template>
  <div
    class="hp--iframe-container"
  >
    <div class="hp--modal-header">
      <div
        class="hp--modal-header-close"
        @click="closeCalendarModal"
      >
        <v-icon
          name="times-circle"
          scale="1.5"
          style="margin-top: 1px"
        />
      </div>
      <div class="hp--modal-header-title">
        Agendar videollamada
      </div>
    </div>
    <div
      class="meetings-iframe-container"
      :data-src="url + '?embed=true'"
    />
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/times-circle'
import { serverUI } from './../../main'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    const script = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    const tag = document.createElement('script')
    tag.setAttribute('src', script)
    tag.setAttribute('type', 'text/javascript')

    document.head.appendChild(tag)
  },
  methods: {
    closeCalendarModal () {
      serverUI.$emit('closeHubspotCalendarModal')
    }
  }
}
</script>

<style>
    .hp--iframe-container {
        display: flex;
        flex-direction: column;
        border: 0;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
    }

    .hp--iframe-container div.meetings-iframe-container {
      display: flex;
      width: 100%;
      height: 100%;
    }

    div.meetings-iframe-container iframe {
      height: auto !important;
      min-height: auto !important;
    }

    div.meetings-iframe-container iframe::-webkit-scrollbar {
      appearance: none;
      -webkit-appearance: none;
      width: 7px;
    }

    div.meetings-iframe-container iframe::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      box-shadow: 0 0 1px hsl(0deg 0% 100% / 50%);
      -webkit-box-shadow: 0 0 1px hsl(0deg 0% 100% / 50%);
    }

    div.meetings-lib.page.embedded div.meetings-page {
      height: 100% !important;
    }

    .hp--modal-header {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
      margin: 10px 10px 0px 10px;
      color: black;
    }

    .hp--modal-header-close {
      width: auto;
      cursor: pointer;
    }

    .hp--modal-header-title {
      font-size: 22px;
      flex: auto;
    }

    div.meetings-lib {
      margin: 0 !important
    }
</style>
